import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Image,
  Svg,
  Path,
} from "@react-pdf/renderer";
import GraphLabel from "../components/PdfComponents/Label";

// Create styles
function getDate() {
  const today = new Date();
  const options = { day: "2-digit", month: "long", year: "numeric" };
  return `${today.toLocaleDateString("en-US", options)}`;
}
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
  },
  sectionTable: {
    margin: 10,
    padding: 10,
    borderRadius: "6.25px",
    overflow: "hidden",
  },
  section: {
    margin: 10,
    padding: 10,
    // border: "2px solid black",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  descSection: {
    margin: 10,
    // padding: 10,
    // border: "2px solid black",
    padding: "0 10px",
    // display: "flex",
    // flexDirection: "row",
    // justifyContent: "space-between",
    // alignItems: "center",
    fontSize: "14px",
  },
  descSectionContainer: {
    margin: "5px",
    color: "rgba(68, 68, 68, 1)",
  },
  descSectionTitle: {
    fontWeight: 600,
  },
  descSectionDesc: {
    fontWeight: 400,
    marginLeft: "10px",
  },
  sectionHeading: {
    fontSize: "18px",
    fontWeight: "700",
  },
  sectionDate: {
    fontSize: "12px",
    fontWeight: "400",
  },
  sectionDateBold: {
    fontWeight: "600",
  },
  sectionHeadingContainer: {
    margin: 10,
    padding: 10,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // border: "2px solid blue",
    // height: "50px",
    gap: "10px",
  },
  sectionLogo: {
    height: "32px",
    width: "32px",
  },
  red: {
    color: "rgba(199, 49, 61, 1)",
  },
  viewer: {
    width: "100%", // Full width
    height: "100vh", // Full height
  },
  header: {
    backgroundColor: "black",
    color: "white",
    padding: "10px 20px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "0.5rem",
  },
  image: {
    height: "32px",
    width: "42px",
  },
  logoText: {
    fontSize: "1rem",
    fontWeight: "1000",
    color: "rgba(255, 0, 0, 1)",
  },
  textWhite: {
    color: "rgba(255, 255, 255, 1)",
  },
  logoDescText: {
    fontSize: "8px",
  },
  footerLogo: {
    height: "24px",
    width: "24px",
  },
  footerLogoContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "0.5rem",
  },
  footerLink: {
    color: "rgba(199, 49, 61, 1)",
    fontSize: "12px",
    fontWeight: "600",
  },
  footerText: {
    fontSize: "10px",
    fontWeight: "400",
  },
  footerRed: {
    fontSize: "10px",
    fontWeight: "600",
    color: "rgba(199, 49, 61, 1)",
  },
  footerContainer: {
    backgroundColor: "black",
    color: "white",
    padding: "10px 20px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    position: "absolute",
    bottom: "0",
    width: "100%",
  },
  desc: {
    fontSize: "12px",
    fontWeight: "400",
  },
  startupCaontainer: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    width: "31%",
  },
  infoContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  borderRight: {
    borderRightWidth: 1,
    borderRightColor: "rgba(204, 204, 204, 1)", // Change color as needed
  },
  startupTitle: {
    fontSize: "12px",
    fontWeight: "400",
  },
  startupValue: {
    fontSize: "14px",
    fontWeight: "600",
  },
  table: {
    width: "100%",
    border: "1px solid transparent",
    borderRadius: "4px",
    overflow: "hidden",
  },
  row: {
    flexDirection: "row",
    overflow: "hidden",
  },
  tableHeader: {
    backgroundColor: "rgba(199, 49, 61, 1)",
    color: "rgba(255, 255, 255, 1)",
    fontWeight: "bold",
    borderTopLeftRadius: "6.5px",
    borderTopRightRadius: "6.5px",
  },
  cell: {
    flex: 1,
    border: "1px solid #000",
    padding: 5,
    textAlign: "center",
  },
  firstCellEmpty: {
    width: "70%",
    textAlign: "left",
    padding: 5,
    paddingLeft: 10,
    fontSize: "10px",
    fontWeight: 400,
  },
  secondCellEmpty: {
    width: "30%", // 30% width for the second column
    padding: 5,
    textAlign: "center",
    fontSize: "10px",
    fontWeight: 400,
  },
  firstCell: {
    width: "70%", // Fixed width for the first column
    border: "1px solid rgba(204, 204, 204, 1)",
    textAlign: "left",
    padding: 5,
    paddingLeft: 10,
    fontSize: "10px",
    fontWeight: 400,
  },
  secondCell: {
    width: "30%", // 30% width for the second column
    border: "1px solid rgba(204, 204, 204, 1)",
    padding: 5,
    textAlign: "center",
    fontSize: "10px",
    fontWeight: 400,
  },
});

// RETURN IMAGE SRC BASED ON STAGE
const getImageSrc = (stage) => {
  switch (stage) {
    case "GROWTH":
      return "/growthgraph.png";
    case "VALLEY":
      return "/valleygraph.png";
    case "MVP":
      return "/valleygraph.png";
    case "IDEA":
      return "/earlygraph.png";
    default:
      return "/graph.png"; // Default image if stage doesn't match
  }
};
// Create Document Component
const MyDocument = ({ formData }) => (
  <Document>
    <Page size="A4" wrap>
      {/* HEADER */}
      <View style={styles.header} fixed>
        <Image src={"/GroupLogo.png"} style={styles.image} />
        <View>
          <Text style={styles.logoText}>
            LOVEN<Text style={styles.textWhite}>CODERS</Text>
          </Text>
          <Text style={styles.logoDescText}>The Elite Startup Lab</Text>
        </View>
      </View>

      {/* SUMMARY */}
      <View style={styles.section}>
        <Text style={[styles.sectionHeading, styles.red]}>
          Startup Evaluation Premium Report
        </Text>
        <Text style={[styles.sectionDate]}>
          <Text style={styles.sectionDateBold}>Date: </Text>
          {getDate()}
        </Text>
      </View>

      {/* SUMMARY DESCRIPTION */}
      <View style={[styles.desc, styles.section]}>
        <Text>
          {formData?.reportSummary ||
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."}
        </Text>
      </View>

      <View style={[styles.section, styles.infoContainer]}>
        <View style={[styles.startupCaontainer, styles.borderRight]}>
          <Text style={[styles.startupTitle]}>Startup Name</Text>
          <Text style={[styles.startupValue]}>
            {formData?.startupName || "NA"}
          </Text>
        </View>
        <View style={[styles.startupCaontainer, styles.borderRight]}>
          <Text style={[styles.startupTitle]}>Contact Number</Text>
          <Text style={[styles.startupValue]}>+91 0000000000</Text>
        </View>
        <View style={[styles.startupCaontainer]}>
          <Text style={[styles.startupTitle]}>Email Id</Text>
          <Text style={[styles.startupValue]}>abc@gmail.com</Text>
        </View>
      </View>

      {/* TABLE */}
      <View style={[styles.sectionTable]}>
        <View style={[styles.row, styles.tableHeader]}>
          <Text style={styles.firstCellEmpty}>Summary</Text>
          <Text style={styles.secondCellEmpty}>%</Text>
        </View>

        {/* Table Rows */}
        <View style={styles.row}>
          <Text style={styles.firstCell}>Total Score</Text>
          <Text style={styles.secondCell}>{formData?.score || "N/A"}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.firstCell}>Stage</Text>
          <Text style={styles.secondCell}>{formData?.stage || "N/A"}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.firstCell}>
            SRI (Self-Assessed Readiness Index)
          </Text>
          <Text style={styles.secondCell}>Jane Smith</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.firstCell}>
            SSI (Calculated Survival Score Index)
          </Text>
          <Text style={styles.secondCell}>Jane Smith</Text>
        </View>

        <View style={[styles.row]}>
          <Text style={[styles.firstCell, { borderBottomLeftRadius: "6.5px" }]}>
            Primary Focus
          </Text>
          <Text
            style={[styles.secondCell, { borderBottomRightRadius: "6.5px" }]}
          >
            Jane Smith
          </Text>
        </View>
      </View>

      {/* RECOMMENDATION */}
      <View
        style={[
          styles.sectionHeadingContainer,
          { flexDirection: "row", alignItems: "center" },
        ]}
      >
        <Image source={"/like.png"} style={styles.sectionLogo} />
        <Text style={[styles.sectionHeading, styles.red]}>Recommendation</Text>
      </View>
      <View style={styles.descSection} wrap={true}>
        {formData?.recommendations.map((recommendation) => (
          <View style={styles.descSectionContainer}>
            <Text style={styles.descSectionTitle}>{recommendation?.title}</Text>
            <Text style={styles.descSectionDesc} break={true}>
              •&nbsp;{recommendation?.description}
            </Text>
          </View>
        ))}
        {/* <Text>Expand marketing efforts to increase customer acquisition.</Text>
        <Text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </Text> */}
      </View>

      {/* PROBLEM DESCRIPTION */}
      <View
        style={[
          styles.sectionHeadingContainer,
          { flexDirection: "row", alignItems: "center" },
        ]}
        break={true}
      >
        <Image source={"/caution.png"} style={styles.sectionLogo} />
        <Text style={[styles.sectionHeading, styles.red]}>
          Problem Description
        </Text>
      </View>
      <View style={styles.descSection}>
        <Text>Expand marketing efforts to increase customer acquisition.</Text>
        <Text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </Text>
      </View>

      {/* GRAPH */}
      <View
        // style={[
        //   styles.sectionHeadingContainer,
        //   { flexDirection: "row", alignItems: "center" },
        // ]}
        style={{ margin: "10px", padding: "10px" }}
        break={true}
      >
        <Text
          style={[styles.sectionHeading, styles.red, { marginBottom: "20px" }]}
        >
          Startup Cashflow vs. Time with Stage Marker
        </Text>
        <GraphLabel />
        <Image
          src={getImageSrc(formData?.stage)}
          style={{ width: "100%", objectFit: "contain", marginTop: "30px" }}
          alt="Stage Graph"
        />
      </View>
      {/* FOOTER */}
      <View style={styles.footerContainer} fixed>
        <View>
          <Text style={styles.footerText}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit
          </Text>
          <Text style={styles.footerRed}>© 2025 Copy Right Reserved</Text>
        </View>
        <View style={styles.footerLogoContainer}>
          <Image src={"/Groupweb.png"} style={styles.footerLogo} />
          <Text style={styles.footerLink}>www.lovenheal.com</Text>
        </View>
      </View>
    </Page>

    <Page size="A4" wrap>
      {/* HEADER */}
      <View style={styles.header} fixed>
        <Image src={"/GroupLogo.png"} style={styles.image} />
        <View>
          <Text style={styles.logoText}>
            LOVEN<Text style={styles.textWhite}>CODERS</Text>
          </Text>
          <Text style={styles.logoDescText}>The Elite Startup Lab</Text>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={[styles.sectionHeading, styles.red]}>
          Survival Score Index (SSI)
        </Text>
      </View>
      <View
        style={[
          styles.section,
          { display: "flex", justifyContent: "center", fontSize: "12px" },
        ]}
      >
        <Text>Survival Score Index (SSI)</Text>
      </View>
      <View
        style={[styles.section, { display: "flex", justifyContent: "center" }]}
      >
        <Svg
          width="320"
          height="162"
          viewBox="0 0 320 162"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            d="M9.93561 120.364V129.673H8.52652V121.773H8.47197L6.2447 123.227V121.882L8.56742 120.364H9.93561Z"
            fill="#222222"
          />
          <Path
            d="M43.9022 58.6082V57.59L47.0522 54.3263C47.3886 53.9718 47.6659 53.6612 47.884 53.3945C48.1053 53.1248 48.2704 52.8688 48.3795 52.6263C48.4886 52.3839 48.5431 52.1263 48.5431 51.8536C48.5431 51.5445 48.4704 51.2779 48.325 51.0536C48.1795 50.8263 47.981 50.6521 47.7295 50.5309C47.478 50.4066 47.1947 50.3445 46.8795 50.3445C46.5462 50.3445 46.2553 50.4127 46.0068 50.5491C45.7583 50.6854 45.5674 50.8779 45.434 51.1263C45.3007 51.3748 45.234 51.6657 45.234 51.9991H43.8931C43.8931 51.4324 44.0234 50.9369 44.284 50.5127C44.5447 50.0885 44.9022 49.7597 45.3568 49.5263C45.8113 49.29 46.328 49.1718 46.9068 49.1718C47.4916 49.1718 48.0068 49.2885 48.4522 49.5218C48.9007 49.7521 49.2507 50.0672 49.5022 50.4672C49.7537 50.8642 49.8795 51.3127 49.8795 51.8127C49.8795 52.1582 49.8143 52.496 49.684 52.8263C49.5568 53.1566 49.334 53.5248 49.0159 53.9309C48.6977 54.3339 48.2553 54.8233 47.6886 55.3991L45.8386 57.3354V57.4036H50.0295V58.6082H43.9022Z"
            fill="#222222"
          />
          <Path
            d="M123.744 13.1273C123.12 13.1273 122.562 13.0197 122.071 12.8045C121.583 12.5894 121.197 12.2909 120.912 11.9091C120.63 11.5242 120.479 11.0788 120.458 10.5727H121.885C121.903 10.8485 121.995 11.0879 122.162 11.2909C122.332 11.4909 122.553 11.6455 122.826 11.7545C123.098 11.8636 123.401 11.9182 123.735 11.9182C124.101 11.9182 124.426 11.8545 124.708 11.7273C124.992 11.6 125.215 11.4227 125.376 11.1955C125.536 10.9652 125.617 10.7 125.617 10.4C125.617 10.0879 125.536 9.81364 125.376 9.57727C125.218 9.33788 124.986 9.15 124.68 9.01364C124.377 8.87727 124.011 8.80909 123.58 8.80909H122.794V7.66364H123.58C123.926 7.66364 124.229 7.60151 124.489 7.47727C124.753 7.35303 124.959 7.1803 125.108 6.95909C125.256 6.73485 125.33 6.47273 125.33 6.17273C125.33 5.88485 125.265 5.63485 125.135 5.42273C125.008 5.20758 124.826 5.03939 124.589 4.91818C124.356 4.79697 124.08 4.73636 123.762 4.73636C123.459 4.73636 123.176 4.79242 122.912 4.90454C122.651 5.01364 122.439 5.17121 122.276 5.37727C122.112 5.5803 122.024 5.82424 122.012 6.10909H120.653C120.668 5.60606 120.817 5.16364 121.098 4.78182C121.383 4.4 121.759 4.10151 122.226 3.88636C122.692 3.67121 123.211 3.56364 123.78 3.56364C124.377 3.56364 124.892 3.6803 125.326 3.91364C125.762 4.14394 126.098 4.45151 126.335 4.83636C126.574 5.22121 126.692 5.64242 126.689 6.1C126.692 6.62121 126.547 7.06364 126.253 7.42727C125.962 7.79091 125.574 8.03485 125.089 8.15909V8.23182C125.708 8.32576 126.186 8.57121 126.526 8.96818C126.868 9.36515 127.038 9.85758 127.035 10.4455C127.038 10.9576 126.895 11.4167 126.608 11.8227C126.323 12.2288 125.933 12.5485 125.439 12.7818C124.945 13.0121 124.38 13.1273 123.744 13.1273Z"
            fill="#222222"
          />
          <Path
            d="M201.311 11.1818V10.0455L205.334 3.69091H206.23V5.36364H205.661L202.784 9.91818V9.99091H208.298V11.1818H201.311ZM205.725 13V10.8364L205.734 10.3182V3.69091H207.066V13H205.725Z"
            fill="#222222"
          />
          <Path
            d="M274.134 58.7354C273.565 58.7354 273.053 58.6263 272.598 58.4082C272.146 58.1869 271.786 57.8839 271.516 57.4991C271.246 57.1142 271.103 56.6748 271.084 56.1809H272.448C272.481 56.5809 272.659 56.9097 272.98 57.1672C273.301 57.4248 273.686 57.5536 274.134 57.5536C274.492 57.5536 274.809 57.4718 275.084 57.3082C275.363 57.1415 275.581 56.9127 275.739 56.6218C275.899 56.3309 275.98 55.9991 275.98 55.6263C275.98 55.2475 275.898 54.9097 275.734 54.6127C275.571 54.3157 275.345 54.0824 275.057 53.9127C274.772 53.743 274.445 53.6566 274.075 53.6536C273.793 53.6536 273.51 53.7021 273.225 53.7991C272.94 53.896 272.71 54.0233 272.534 54.1809L271.248 53.99L271.771 49.2991H276.889V50.5036H272.939L272.643 53.1082H272.698C272.88 52.9324 273.121 52.7854 273.421 52.6672C273.724 52.5491 274.048 52.49 274.393 52.49C274.96 52.49 275.465 52.6248 275.907 52.8945C276.353 53.1642 276.703 53.5324 276.957 53.9991C277.215 54.4627 277.342 54.996 277.339 55.5991C277.342 56.2021 277.206 56.74 276.93 57.2127C276.657 57.6854 276.278 58.0582 275.793 58.3309C275.312 58.6006 274.759 58.7354 274.134 58.7354Z"
            fill="#222222"
          />
          <Path
            d="M311.544 129.8C311.128 129.794 310.719 129.718 310.316 129.573C309.916 129.427 309.553 129.185 309.225 128.846C308.898 128.506 308.636 128.05 308.439 127.477C308.245 126.905 308.148 126.19 308.148 125.332C308.148 124.52 308.228 123.799 308.389 123.168C308.553 122.538 308.788 122.006 309.094 121.573C309.4 121.136 309.769 120.805 310.203 120.577C310.636 120.35 311.122 120.236 311.662 120.236C312.216 120.236 312.709 120.346 313.139 120.564C313.569 120.782 313.918 121.083 314.185 121.468C314.454 121.853 314.625 122.291 314.698 122.782H313.312C313.218 122.394 313.032 122.077 312.753 121.832C312.474 121.586 312.11 121.464 311.662 121.464C310.98 121.464 310.448 121.761 310.066 122.355C309.688 122.949 309.497 123.774 309.494 124.832H309.562C309.722 124.568 309.919 124.344 310.153 124.159C310.389 123.971 310.653 123.827 310.944 123.727C311.238 123.624 311.547 123.573 311.871 123.573C312.41 123.573 312.898 123.705 313.335 123.968C313.774 124.229 314.124 124.59 314.385 125.05C314.645 125.511 314.775 126.038 314.775 126.632C314.775 127.226 314.641 127.764 314.371 128.246C314.104 128.727 313.728 129.109 313.244 129.391C312.759 129.67 312.192 129.806 311.544 129.8ZM311.539 128.618C311.897 128.618 312.216 128.53 312.498 128.355C312.78 128.179 313.003 127.943 313.166 127.646C313.33 127.349 313.412 127.017 313.412 126.65C313.412 126.293 313.332 125.967 313.171 125.673C313.013 125.379 312.795 125.146 312.516 124.973C312.241 124.8 311.925 124.714 311.571 124.714C311.301 124.714 311.051 124.765 310.821 124.868C310.594 124.971 310.394 125.114 310.221 125.296C310.048 125.477 309.912 125.686 309.812 125.923C309.715 126.156 309.666 126.403 309.666 126.664C309.666 127.012 309.747 127.335 309.907 127.632C310.071 127.929 310.294 128.168 310.575 128.35C310.86 128.529 311.182 128.618 311.539 128.618Z"
            fill="#222222"
          />
          <Path
            d="M125.189 95.1901L93.6258 40.9453C72.5786 53.0525 55.0338 70.5001 42.8594 91.4261L97.4094 122.811C104.065 111.355 113.665 101.806 125.189 95.1901Z"
            fill="#FFA5A6"
          />
          <Path
            d="M125.189 95.1901L93.6258 40.9453C72.5786 53.0525 55.0338 70.5001 42.8594 91.4261L97.4094 122.811C104.065 111.355 113.665 101.806 125.189 95.1901Z"
            stroke="white"
            strokeWidth="2.45007"
            strokeMiterlimit="10"
          />
          <Path
            d="M162.964 85.1508V22.4893C137.704 22.4893 114.022 29.2094 93.625 40.9447L125.188 95.1895C136.302 88.8054 149.203 85.1508 162.964 85.1508Z"
            fill="#F58D8D"
          />
          <Path
            d="M162.964 85.1508V22.4894C137.704 22.4894 114.022 29.2094 93.625 40.9447L125.188 95.1895C136.302 88.8054 149.203 85.1508 162.964 85.1508Z"
            stroke="white"
            strokeWidth="2.45007"
            strokeMiterlimit="10"
          />
          <Path
            d="M228.521 122.811L283.071 91.4261C270.897 70.5001 253.348 53.0525 232.305 40.9457L200.742 95.1901C212.266 101.806 221.866 111.355 228.521 122.811Z"
            fill="#C7313D"
          />
          <Path
            d="M228.521 122.811L283.071 91.4261C270.897 70.5001 253.348 53.0525 232.305 40.9457L200.742 95.1901C212.266 101.806 221.866 111.355 228.521 122.811Z"
            stroke="white"
            strokeWidth="2.45007"
            strokeMiterlimit="10"
          />
          <Path
            d="M200.741 95.1895L232.304 40.9451C211.908 29.2093 188.226 22.4893 162.965 22.4893V85.1508C176.726 85.1508 189.627 88.8054 200.741 95.1895Z"
            fill="#DC4B4D"
          />
          <Path
            d="M200.741 95.1895L232.304 40.9451C211.908 29.2093 188.226 22.4894 162.965 22.4894V85.1508C176.726 85.1508 189.627 88.8054 200.741 95.1895Z"
            stroke="white"
            strokeWidth="2.45007"
            strokeMiterlimit="10"
          />
          <Path
            d="M238.613 160.376H301.63C301.63 135.257 294.871 111.709 283.07 91.4259L228.52 122.81C234.938 133.865 238.613 146.693 238.613 160.376Z"
            fill="#962F30"
          />
          <Path
            d="M238.613 160.376H301.631C301.631 135.257 294.871 111.709 283.07 91.4259L228.52 122.81C234.938 133.865 238.613 146.693 238.613 160.376Z"
            stroke="white"
            strokeWidth="2.45007"
            strokeMiterlimit="10"
          />
          <Path
            d="M97.4078 122.81L42.8578 91.4259C31.0569 111.709 24.2969 135.257 24.2969 160.376H87.314C87.314 146.693 90.9892 133.865 97.4078 122.81Z"
            fill="#FEC2C2"
          />
          <Path
            d="M97.4078 122.81L42.8578 91.4259C31.0569 111.709 24.2969 135.257 24.2969 160.376H87.314C87.314 146.693 90.9892 133.865 97.4078 122.81Z"
            stroke="white"
            strokeWidth="2.45007"
            strokeMiterlimit="10"
          />
        </Svg>

        <Svg
          style={{
            border: "2px solid blue",
            transform: `rotate(-90deg)`,
            transformOrigin: "left center",
            position: "absolute",
            left: "50%",
            top: "90%",
          }}
          width="133"
          height="17"
          viewBox="0 0 133 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            d="M5.38227 10.3685C5.25374 8.55844 6.62747 6.98919 8.44701 6.86337C10.2706 6.73796 11.849 8.10392 11.9735 9.91402C12.098 11.7241 10.7244 13.2934 8.90484 13.4188C7.0853 13.5442 5.50679 12.1786 5.38227 10.3685ZM132.453 2.70716L132.3 0.519619L6.55918 3.53193C4.1251 3.67132 1.95203 5.10239 0.871549 7.27875C-0.208929 9.45471 -0.0281487 12.04 1.34554 14.0475C2.71522 16.0545 5.06493 17.174 7.49902 16.9779L132.453 2.70716Z"
            fill="#231F20"
          />
        </Svg>
      </View>
      <View style={{position: "absolute", top: "41%", width: "100%",}}>
        <Text
          style={{
            border: "1px solid rgba(204, 204, 204, 1)",
            width: "80%",
            margin: "auto",
            position: "absolute",
            left: "10%",
            backgroundColor:"rgba(204, 204, 204, 1)",
          }}
        ></Text>
      </View>
      <View
        style={[
          styles.section,
          { display: "flex", justifyContent: "center", fontSize: "14px" },
        ]}
      >
        <Text>SSI Value (1 = Very Low, 6 = Very High)</Text>
      </View>
      {/* FOOTER */}
      <View style={styles.footerContainer} fixed>
        <View>
          <Text style={styles.footerText}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit
          </Text>
          <Text style={styles.footerRed}>© 2025 Copy Right Reserved</Text>
        </View>
        <View style={styles.footerLogoContainer}>
          <Image src={"/Groupweb.png"} style={styles.footerLogo} />
          <Text style={styles.footerLink}>www.lovenheal.com</Text>
        </View>
      </View>
    </Page>
  </Document>
);

// Full-page PDF viewer
const PDFPage = () => (
  <PDFViewer style={styles.viewer}>
    <MyDocument />
  </PDFViewer>
);

export default PDFPage;
export { MyDocument };
